"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shaStr = void 0;
const sha_js_1 = require("sha.js");
exports.shaStr = (input) => new sha_js_1.sha256().update(input).digest("hex");
//# sourceMappingURL=utils.js.map